import { useParams } from "react-router-dom";
import { motion } from "framer-motion";

const blogData = [
  {
    id: "1",
    title: "Are Refurbished Laptops Worth It in 2026?",
    img: "https://images.unsplash.com/photo-1517336714731-489689fd1ca8",
    date: "April 2026",
    content: `
Refurbished laptops have become very popular in India due to their affordability and performance.

💻 What are refurbished laptops?
They are pre-owned laptops that are tested, repaired, and certified to work like new.

✅ Benefits:
- Lower price (30–50% cheaper)
- Good performance
- Eco-friendly choice

⚠️ Things to check:
- Warranty
- Battery health
- Seller credibility

👉 Final Verdict:
Yes, refurbished laptops are totally worth it if you buy from a trusted seller.
    `,
  },
  {
    id: "2",
    title: "Top 5 Refurbished Laptops Under ₹30,000",
    img: "https://images.unsplash.com/photo-1496181133206-80ce9b88a853",
    date: "March 2026",
    content: `
Here are the best refurbished laptops under ₹30,000:

1. Dell Latitude Series
2. HP EliteBook
3. Lenovo ThinkPad
4. Acer Aspire
5. ASUS VivoBook

👉 Best for:
- Students
- Office work
- Coding beginners

💡 Tip:
Always check RAM (8GB recommended) and SSD.
    `,
  },
];

const BlogDetail = () => {
  const { id } = useParams();

  const blog = blogData.find((b) => b.id === id);

  if (!blog) {
    return <div className="p-5">Blog not found</div>;
  }

  return (
    <div className="bg-gray-50 min-h-screen py-10 px-4">

      <div className="max-w-3xl mx-auto">

        {/* IMAGE */}
        <motion.img
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          src={blog.img}
          alt={blog.title}
          className="w-full h-52 md:h-80 object-cover rounded-2xl shadow"
        />

        {/* CONTENT */}
        <div className="mt-6 bg-white rounded-2xl shadow p-5 md:p-8">

          {/* TITLE */}
          <h1 className="text-xl md:text-3xl font-bold text-gray-800">
            {blog.title}
          </h1>

          {/* DATE */}
          <p className="text-xs text-gray-400 mt-1">{blog.date}</p>

          {/* TEXT */}
          <div className="mt-4 text-gray-700 text-sm md:text-base leading-relaxed whitespace-pre-line">
            {blog.content}
          </div>

          {/* CTA */}
          <div className="mt-6 p-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-xl text-center">
            <p className="text-sm md:text-base font-semibold">
              Looking for best refurbished laptops?
            </p>
            <button className="mt-2 bg-white text-black px-4 py-2 rounded-lg text-sm">
              Shop Now
            </button>
          </div>

        </div>

      </div>
    </div>
  );
};

export default BlogDetail;